export default "__VITE_ASSET__BEi3Q6A2__"